export default {
  containerRef: null,

  init(containerRef: React.RefObject<Element>): void {
    this.containerRef = containerRef;
  },

  /* eslint-disable complexity */
  resize(): null {
    return null;
  },
};
